var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"content-center"},[_c('iframe',{staticClass:"scheme-chat-iframe",attrs:{"src":"https://ai.591ylc.com/chat/share?shareId=gLuvD0djB1CsBgGNKssDk3mf&showHistory=0","frameborder":"0","allow":"microphone *; *"}})])])
}]

export { render, staticRenderFns }